import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import FitScoreLogo from './FitScoreLogo';
import './Navigation.css';

function Navigation() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navigation">
      <div className="container nav-container">
        <div className="nav-left">
          <Link to="/services/fit-app" className="nav-cta-btn">F-IT App</Link>
          <span className="nav-tagline">Personal Wellbeing Tracking. Organisational Intelligence.</span>
        </div>
        
        <button className="mobile-toggle" onClick={() => setIsOpen(!isOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
          <li><Link to="/" onClick={() => setIsOpen(false)}>Home</Link></li>
          <li><Link to="/about" onClick={() => setIsOpen(false)}>About</Link></li>
          <li><Link to="/how-it-works" onClick={() => setIsOpen(false)}>How It Works</Link></li>
          <li><Link to="/why-it-works" onClick={() => setIsOpen(false)}>Why It Works</Link></li>
          <li><Link to="/security" onClick={() => setIsOpen(false)}>Security</Link></li>
          <li><Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
